
export const ReportModuleTypesEnum = {
    Crm: {
        key: 1,
        value: 'CRM',
    },
    Sales: {
        key: 2,
        value: 'Sales',
    },
    Leasing: {
        key: 3,
        value: 'Leasing,',
    },
    CallCenter: {
        key: 4,
        value: 'CallCenter',
    },
    PropertyManagement:
    {
        key: 5,
        value: 'PropertyManagement',
    },
    Accounts:
    {
        key: 6,
        value: 'Accounts',
    },
};
